"use strict";

exports.__esModule = true;
exports.default = void 0;

var _pallette = _interopRequireDefault(require("./pallette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled-components theme for Reassure-UI panel components
 */
const {
  transparent,
  white,
  lightBlue,
  darkBlue,
  midRed
} = _pallette.default;
var _default = {
  colors: {
    accordion: {
      background: lightBlue,
      border: lightBlue
    },
    card: {
      text: white,
      background: lightBlue,
      border: lightBlue,
      boxShadow: '0 12px 24px rgba(0,0,0,.08)',
      contrast: {
        text: white,
        background: darkBlue,
        border: darkBlue
      },
      error: {
        text: white,
        background: midRed,
        border: midRed
      }
    },
    drawer: {
      text: white,
      background: darkBlue,
      contrast: {
        text: white,
        background: lightBlue
      }
    },
    errorCard: {
      text: white,
      background: transparent,
      border: midRed
    }
  }
};
exports.default = _default;